interface IMockedProjects {
  code: string
  description: string
  id: number
  isActive: boolean
}

export const mockedProjects: IMockedProjects[] = [
  {
    code: 'BI20',
    description: 'Billings Majors Project',
    isActive: true,
    id: 38,
  },
  {
    code: 'BI01',
    description: 'Billings Admin. Project',
    isActive: true,
    id: 39,
  },
  {
    code: 'BI02',
    description: 'Billings Maintenance Project',
    isActive: true,
    id: 40,
  },
]
